import React from "react";
import NotificationListPage from "../../components/call-center/NotificationListPage";

const CallCenterPaymentConfirmationsPage = () => (
  <NotificationListPage
    notificationType="PAYMENT_CONFIRMED"
    titleKey="ccNotificationsConfirmationsSection"
    emptyMessageKey="ccNotificationsConfirmationsEmpty"
    fallbackTitleKey="ccNotificationsPaymentConfirmedTitle"
  />
);

export default CallCenterPaymentConfirmationsPage;
